import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.bgPage,
  flexGrow: 1,
}));

export const Block = styled("div")(({ theme }) => ({
  ...theme.mixins.flexJustifyBetween,
  alignItems: "flex-start",
  gap: 20,
  padding: "10px 0",

  [theme.down("lg")]: {
    flexDirection: "column",
  },
}));

export const LoadingBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  width: "100%",
  minHeight: 500,
  backgroundColor: theme.palette.bgPage,
}));

export const ErrorBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  flexDirection: "column",
  width: "100%",
  minHeight: 500,
  backgroundColor: theme.palette.bgPage,
}));

export const SessionBlock = styled("div")(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.textSecondary,
  marginTop: 5,
}));

export const ModalBlock = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: 500,
  height: 'auto',
  padding: 20,

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  gap: 20,
  
  "&>button": {
    width: "100%",
    maxWidth: 200,
    padding: "10px 20px",
    color: theme.palette.white,

    border: "none",
    borderRadius: 5,

    backgroundColor: theme.palette.searchButtonBg,
    cursor: "pointer",
    fontSize: 16,
    transition: "background-color 0.3s ease",

    "&:hover": {
      backgroundColor: theme.palette.hoverButtonBg,
    },
  },
}));
